export default "__VITE_ASSET__2rjkMRqA__"